
<footer class="footer">
    <div class="footer-list" style="max-width: 300px; margin: 0 auto;">
        <a [routerLink]="['/dashboard']" routerLinkActive="router-link-active" class="footer-item" [ngClass]="selectedPath == '/dashboard' ? 'active' : '' ">
            <p><i class="ti ti-home"></i></p>
            <p>Home</p>
        </a>
        <a class="footer-item cursorClass" (click)="logOut()">
            <p><i class="ti ti-logout"></i></p>
            <p>Log Out</p>
        </a>
    </div>
</footer>